import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import Line from "../assets/img/Line.png";

import { useParams, useNavigate } from "react-router-dom";

import { HiOutlineArrowNarrowLeft } from "react-icons/hi";

import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
import { useContext } from "react";
import UserContext from "../../context/UserContext";

const FolderTemplateFileShow = () => {
  const navigate = useNavigate();
  const { decryptData } = useEncryption();

  let { id, fileId } = useParams();
  const [fileData, setFileData] = useState({}); // Edit API Data set
  const [fileUrl, setFileUrl] = useState(null);

  const { selectedFolder1 } = useContext(UserContext);
  console.log("🚀 ~ FolderTemplateFileShow ~ selectedFolder1===============================:", selectedFolder1)
  const { setSelectedFolder1 } = useContext(UserContext);

  const getViewFile = async () => {
    await axiosInstanceAuth
      .post(`view_single_file/${id}`, { file_id: fileId })
      .then((res) => {
        const myFileData = decryptData(res?.data?.data);
        setFileData(myFileData?.data);
        // console.log("first")
        // console.log("User ==== ++++ ====== ile File ID Wise --->", myFileData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getViewFile();
  }, []);

  useEffect(() => {
    if (fileData?.data) {
      const url = `${BACKEND_BASE_URL}${fileData?.data}`;
      setFileUrl(url);
    }
  }, [fileData?.data]);

  const renderFile = () => {
    if (fileUrl) {
      // Split the file name to get the file extension
      const fileNameParts = fileData?.data.split(".");
      const fileExtension =
        fileNameParts[fileNameParts.length - 1].toLowerCase();

      return (
        <iframe
          src={fileUrl}
          title="File Viewer"
          width="100%"
          height="800px" // Set the height as per your requirement
          frameBorder="0"
          scrolling="auto"
          allowFullScreen
        />
      );
    }

    return <div>No file available</div>;
  };

  const backButtonClick = () => {
    if(selectedFolder1)
    {
      navigate("/records");
    }
    else{
      
      navigate("/")
    }
    // window.history.back();
  };

  return (
    <Layout>
      <div className="container">
        <div className="md:flex justify-between lg:my-10 my-3">
          <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
            <img src={Line} alt="" className="h-7" />
            <h1 className="text-[#22345C]">View File</h1>
          </div>
        </div>

        <div>
          <button
            onClick={backButtonClick}
            class="bg-[#22345C] gap-1  text-[#FFFFFF] font-sans text-lg font-bold py-1.5 px-2 rounded-[10px] inline-flex items-center"
          >
            <HiOutlineArrowNarrowLeft size={25} className="text-[#FFFFFF]" />
            <span>Back</span>
          </button>
        </div>

        {/* <div>
          <div className="overflow-auto lg:overflow-visible mt-5">
            <table className="table w-full text-gray-400 border-separate space-y-6">
              <tbody>
                <tr className="bg-[#F5F7FD] lg:text-black  font-sans text-lg">
                  <td className="p-1.5 space-y-">
                    <strong>Attechment : </strong>
                    {renderFile()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> */}

        <div>
          <div className="overflow-auto lg:overflow-visible mt-5">
            {renderFile()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FolderTemplateFileShow;
